import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BusinessStateService } from '../../services/business-state.service';
import { Routes } from '../../routes/routes';
import { Routes as AppRoutes } from '@core/routes/routes';
import { AuthService, UserRole } from '../services/auth-service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const businessStateService = inject(BusinessStateService);

  if (authService.isAuthenticated()) {
    // Verificar acceso a la ruta /forms - requiere selección de sede
    if (route.routeConfig?.path === Routes.formsPage) {
      if (!businessStateService.isOfficeSelected()) {
        router.navigate(['/dashboard']);
        return false;
      }
    }

    return true;
  }

  router.navigate(['/login']);
  return false;
};

export const adminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (!authService.isAuthenticated()) {
    return router.createUrlTree([AppRoutes.loginPage]);
  }

  if (authService.hasRole(UserRole.ADMIN)) {
    return true;
  }

  return router.createUrlTree([AppRoutes.dashboardPage]);
};
